/* conexiones locales */
/* const conCategorias = 'http://localhost/test/mantenedor/servicios/listaCategorias.php';
const conProyectos = 'http://localhost/test/mantenedor/servicios/listaProyectos.php'; 
const conCursos = 'http://localhost/test/mantenedor/servicios/listaCursos.php';
const conExperiencia = 'http://localhost/test/mantenedor/servicios/listaExperiencias.php';
const conMiniaturas = 'http://localhost/test/images/proyectos/';
const conProyectosImg = 'http://localhost/test/images/proyectos/';
 */
/* conexiones produccion */
const conCategorias = 'https://www.davmund.cl/mantenedor/servicios/listaCategorias.php';
const conProyectos = 'https://www.davmund.cl/mantenedor/servicios/listaProyectos.php';
const conCursos = 'https://davmund.cl/mantenedor/servicios/listaCursos.php';
const conExperiencia = 'https://davmund.cl/mantenedor/servicios/listaExperiencias.php';
const conMiniaturas = 'https://davmund.cl/images/proyectos/';
const conProyectosImg = 'https://davmund.cl/images/proyectos/';

/* cv download*/
const cvDownload = 'https://docs.google.com/document/d/1-tBDG9wlbktGHyIfj3kU0Tx6xAqFShhXltS_jm2lTT0/edit?usp=sharing';
const cvDownload_en = 'https://docs.google.com/document/d/1ZkyvQSSbh3KiQW2Iwb1Tj__sjywYvtk5qQdQHvoYkmY/edit?usp=sharing';

export {
    conCategorias,
    conProyectos,
    conCursos,
    conExperiencia,
    conMiniaturas,
    conProyectosImg,
    cvDownload,
    cvDownload_en
};